module.exports = __webpack_public_path__ + "static/media/boy-6.eae9622f.svg";